module.exports = __webpack_public_path__ + "static/media/img8.cbf0897e.jpg";